import React, { useState } from "react";

const faqs = [
  {
    question: "How do I reset my streak?",
    answer:
      "Go to the habit details page, tap the options menu (three dots), and select 'Reset Streak'.",
  },
  {
    question: "How does Streak Protection work?",
    answer:
      "Streak Protection lets you pause a habit for a single day or multiple days without breaking your streak. Find it in the habit options menu.",
  },
  {
    question: "Can I export my habit data?",
    answer:
      "Yes. Go to Settings > Data Management > Export Data to save your habit history.",
  },
  {
    question: "Is my data private?",
    answer:
      "All data is stored locally on your device. Nothing is sent to external servers. See the Privacy & Terms tab for full details.",
  },
];

const Support: React.FC = () => {
  const [copied, setCopied] = useState<boolean>(false);

  const copyToClipboard = (): void => {
    navigator.clipboard.writeText("skystanoyevitch@proton.me");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      style={{
        padding: "clamp(32px, 5vw, 48px) clamp(24px, 5vw, 40px)",
        fontFamily: "'Outfit', sans-serif",
      }}
    >
      {/* Header */}
      <p
        style={{
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "0.12em",
          textTransform: "uppercase" as const,
          color: "#2A3D4A",
          margin: "0 0 16px",
        }}
      >
        Get In Touch
      </p>
      <h2
        style={{
          fontSize: "clamp(1.75rem, 4vw, 2.375rem)",
          fontWeight: 700,
          letterSpacing: "-0.02em",
          lineHeight: 1.15,
          color: "#2A3D4A",
          margin: "0 0 14px",
        }}
      >
        Support
      </h2>
      <p
        style={{
          fontSize: "16px",
          fontWeight: 300,
          lineHeight: 1.65,
          color: "#2A3D4A",
          maxWidth: "480px",
          margin: "0 0 40px",
          letterSpacing: "0.01em",
        }}
      >
        Have a question or ran into an issue? Reach out — responses typically
        come within 24 hours.
      </p>

      {/* Email Card */}
      <div
        style={{
          border: "1px solid #2A3D4A",
          padding: "24px",
          marginBottom: "40px",
        }}
      >
        <p
          style={{
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.10em",
            textTransform: "uppercase" as const,
            color: "#8FA4B8",
            margin: "0 0 12px",
          }}
        >
          Email
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap" as const,
            gap: "16px",
          }}
        >
          <span
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "#2A3D4A",
              letterSpacing: "0.01em",
            }}
          >
            skystanoyevitch@proton.me
          </span>
          <button
            onClick={copyToClipboard}
            style={{
              padding: "8px 16px",
              background: copied ? "#2A3D4A" : "transparent",
              border: "1px solid #2A3D4A",
              color: copied ? "#FFFFFF" : "#2A3D4A",
              fontFamily: "'Outfit', sans-serif",
              fontSize: "13px",
              fontWeight: 500,
              letterSpacing: "0.04em",
              cursor: "pointer",
              transition: "all 0.18s ease",
              borderRadius: "4px",
            }}
          >
            {copied ? "Copied" : "Copy"}
          </button>
        </div>
        <p
          style={{
            fontSize: "13px",
            fontWeight: 300,
            color: "#8FA4B8",
            margin: "12px 0 0",
            letterSpacing: "0.01em",
          }}
        >
          Responses within 24–48 hours, Monday – Friday.
        </p>
      </div>

      {/* FAQ */}
      <p
        style={{
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "0.10em",
          textTransform: "uppercase" as const,
          color: "#2A3D4A",
          margin: "0 0 20px",
        }}
      >
        Common Questions
      </p>
      <div>
        {faqs.map((faq, i) => (
          <FaqItem
            key={i}
            question={faq.question}
            answer={faq.answer}
            last={i === faqs.length - 1}
          />
        ))}
      </div>
    </div>
  );
};

interface FaqItemProps {
  question: string;
  answer: string;
  last: boolean;
}

const FaqItem: React.FC<FaqItemProps> = ({ question, answer, last }) => (
  <div
    style={{
      padding: "20px 0",
      borderBottom: last ? "none" : "1px solid rgba(42,61,74,0.12)",
    }}
  >
    <h4
      style={{
        fontFamily: "'Outfit', sans-serif",
        fontSize: "16px",
        fontWeight: 700,
        color: "#2A3D4A",
        margin: "0 0 8px",
        letterSpacing: "-0.01em",
      }}
    >
      {question}
    </h4>
    <p
      style={{
        fontFamily: "'Outfit', sans-serif",
        fontSize: "15px",
        fontWeight: 300,
        color: "#2A3D4A",
        margin: 0,
        lineHeight: 1.6,
        letterSpacing: "0.01em",
      }}
    >
      {answer}
    </p>
  </div>
);

export default Support;
